import ajax from '../utils/ajax'

export default {
    load: type => ajax.get("/api/plots/practice", {params: {type}}),
    exam: (practice, detail) => ajax.get(`/api/practices/${practice}/items/${detail}/plots`),
};
